// extracted by mini-css-extract-plugin
module.exports = {"avatar-wrap":"avatar-wrap___3P6kZ"};